<template>
  <transition 
    v-on="$listeners"
    :name="name"
    mode="out-in">
    <slot/>
  </transition>
</template>

<script>
export default {
  
  name: 'Animation',

  props: {
    name: {
      type: String,
      default: 'slide-left'
    }
  }

}

</script>


<style>

/* Slide left */ 
.slide-left-leave-active,
.slide-left-enter-active {
  transition: 200ms ease-in-out;
  opacity: 1;
}

.slide-left-enter {
  transform: translate(30px, 0);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translate(-10px, 0);
  opacity: 0;
}

/* Slide right */ 
.slide-right-leave-active,
.slide-right-enter-active {
  transition: 200ms ease-in-out;
  opacity: 1;
}

.slide-right-enter {
  transform: translate(-10px, 0);
  opacity: 0;
}

.slide-right-leave-to {
  transform: translate(30px, 0);
  opacity: 0;
}


/* Fade */ 
.fade-enter-active, .fade-leave-active {
  transition: opacity 200ms;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* Fade Slow */ 
.fade-slow-enter-active, 
.fade-slow-leave-active {
  transition: opacity 350ms;
}
.fade-slow-enter, 
.fade-slow-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* Fade Up */ 
.fade-up-enter-active, 
.fade-up-leave-active {
  transform: translateY(0);
  transition: all 350ms;
}

.fade-up-enter, 
.fade-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-200px);
  opacity: 0;
}
</style>